import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import QualityApiFacade from "./QualityApiFacade";
import { getNewRefreshInterval } from "../../overview/utils/utils";

const QualityContext = createContext();

export const QualityProvider = ({
  children,
  stationCode,
  startDate,
  endDate,
}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const intervalRef = useRef();

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await QualityApiFacade.getQualityMetricsData(
        { stationCode, startDate, endDate },
        (err) => setError(err),
      );
      setData(result);
      console.debug("API Response:", result);
    } catch (err) {
      console.error("Error fetching data:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();

    // Set up interval for refreshing data
    const refreshMs = getNewRefreshInterval();
    intervalRef.current = setInterval(() => {
      fetchData();
    }, refreshMs);

    // Cleanup on unmount or when dependencies change
    return () => {
      clearInterval(intervalRef.current);
    };
  }, [stationCode, startDate, endDate]);

  return (
    <QualityContext.Provider value={{ data, loading, error }}>
      {children}
    </QualityContext.Provider>
  );
};

export const useQuality = () => useContext(QualityContext);



// WEBPACK FOOTER //
// ./src/components/quality/common/QualityContext.js